import { createTheme as createMuiTheme } from '@mui/material/styles'

import { mixins } from './core/mixins'
import { shadows } from './core/shadows'
import { palette } from './core/palette'
import { themeConfig } from './theme-config'
import { components } from './core/components'
import { typography } from './core/typography'
import { customShadows } from './core/custom-shadows'
import {
  updateCoreWithSettings,
  updateComponentsWithSettings
} from './with-settings'

// ----------------------------------------------------------------------

export const baseTheme = {
  colorSchemes: {
    light: {
      palette: palette.light,
      shadows: shadows.light,
      customShadows: customShadows.light
    },
    dark: {
      palette: palette.dark,
      shadows: shadows.dark,
      customShadows: customShadows.dark
    }
  },
  mixins,
  components,
  typography,
  shape: { borderRadius: 8 },
  direction: themeConfig.direction,
  cssVariables: themeConfig.cssVariables,
  defaultColorScheme: themeConfig.defaultMode
}

// ----------------------------------------------------------------------

export function createTheme({
  settingsState,
  themeOverrides = {},
  localeComponents = {}
} = {}) {
  // Update core theme settings
  const updatedCore = settingsState
    ? updateCoreWithSettings(baseTheme, settingsState)
    : baseTheme

  // Update component settings
  const updatedComponents = settingsState
    ? updateComponentsWithSettings(components, settingsState)
    : {}

  // Create and return the final theme
  const theme = createMuiTheme(
    updatedCore,
    updatedComponents,
    localeComponents,
    themeOverrides,
    {
      zIndex: {
        mobileStepper: 910,
        fab: 920,
        speedDial: 930,
        appBar: 940,
        drawer: 950,
        modal: 960,
        snackbar: 970,
        tooltip: 980
      }
    }
  )

  return theme
}
